<template lang="pug">
  button.botao-redondo(@click="acao")
    .botao-redondo__icone
      slot(v-if="$slots.default")
    p.botao-redondo__titulo {{ titulo }}
</template>

<script>
export default {
  name: 'BotaoRedondo',
  props: {
    titulo: {
      type: String,
      default: ''
    }
  },
  methods: {
    acao () {
      this.$emit('click')
    }
  }
}
</script>

<style scoped>
.botao-redondo {
  display: flex;
  align-items: center;
  gap: 8px;
  flex-direction: column;

  cursor: pointer;
  border: unset;
  color: #2C3E50;
  background-color: unset;
  font-size: 18px;
  font-weight: 300;
  line-height: 21px;
}

.botao-redondo__icone {
  display: flex;
  justify-content: center;
  align-items: center;

  width: 50px;
  height: 50px;
  border-radius: 50%;
  background: #F5F5F5;
}

.botao-redondo__titulo {
  max-width: 100px;
}
</style>
